/**
 * Chef Banchan Weekly Deal Manager - V3.6
 * DOM-based + Drawer + Calendar Filter (이번 주/다음 주 월~토)
 * 특가 포함 전체 합산으로 $120 체크
 * 우선순위: event-system > weekly deal
 * CSS 클래스 방식 수량 잠금 (다른 상품 수량 변경 방해 안 함)
 * V3.3: 김치 사전예약 + 1+1 동시 담기 방지
 * V3.4: 무료증정 아이템(0IO-0NI-00) 감지 시 최소주문금액 $120 → $100 변경
 *        무료증정 아이템도 수량 1개 고정
 * V3.5: 무료증정 감지를 SKU → Variant ID 방식으로 변경 (DOM에 data-sku 없는 문제 해결)
 * V3.6: EG 앱 제거 → 스크립트로 무료증정 자동 add/remove
 *        Shop 메타필드(freegift.start_date / freegift.end_date)에서 날짜 읽기
 *        조건: cartTotal >= $100 + 배송일이 메타필드 범위 내
 */

(function() {
  console.log('🎯 Weekly Deal Manager V3.14 Start');
  
  var DEAL_TAG = 'weekly-deal';
  var DEFAULT_MIN_CART_TOTAL = 120.00;
  var FREE_GIFT_MIN_CART_TOTAL = 100.00;
  var MIN_CART_TOTAL = DEFAULT_MIN_CART_TOTAL; // 동적으로 변경됨
  var MAX_DEAL_QUANTITY = 1;
  var KIMCHI_SKUS = ['0DG-0IB-00', '0DH-0IC-00'];
  var FREE_GIFT_SKU = '0IO-0NI-00';                    // 무료증정 SKU (API fallback용)
  var FREE_GIFT_VARIANT_ID = '48199414776033';          // 무료증정 Variant ID (DOM 감지용)
  
  var isProcessing = false;
  var isFreeGiftProcessing = false; // 무료증정 add/remove 처리 중 플래그
  var hasDealInCart = false;
  var hasFreeGiftInCart = false;
  var calendarInitialized = false;
  var lastFreeGiftState = null; // 마지막 무료증정 상태 캐시 (중복 실행 방지)
  
  // ===================================
  // 📅 배송 날짜 범위 계산
  // ===================================
  
  function getWeeklyDealDateRange() {
    // 메타필드 값 우선 사용 (window.freeGiftConfig)
    var config = window.freeGiftConfig;
    if (config && config.startDate && config.endDate) {
      var start = new Date(config.startDate + 'T00:00:00');
      var end = new Date(config.endDate + 'T23:59:59');
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);
      console.log('📅 Weekly Deal 배송 범위 (메타필드):', config.startDate, '~', config.endDate);
      return { start: start, end: end, startStr: config.startDate, endStr: config.endDate };
    }

    // 메타필드 없을 때 fallback: 자동 계산 (이번주/다음주 월~토)
    var now = new Date();
    var currentDay = now.getDay();
    var daysToMonday;
    if (currentDay === 0) {
      daysToMonday = 1;
    } else if (currentDay >= 5) {
      daysToMonday = 8 - currentDay;
    } else {
      daysToMonday = 1 - currentDay;
    }
    var targetMonday = new Date(now);
    targetMonday.setDate(now.getDate() + daysToMonday);
    targetMonday.setHours(0, 0, 0, 0);
    var targetSaturday = new Date(targetMonday);
    targetSaturday.setDate(targetMonday.getDate() + 5);
    targetSaturday.setHours(23, 59, 59, 999);
    var startStr = targetMonday.getFullYear() + '-' +
      String(targetMonday.getMonth() + 1).padStart(2, '0') + '-' +
      String(targetMonday.getDate()).padStart(2, '0');
    var endStr = targetSaturday.getFullYear() + '-' +
      String(targetSaturday.getMonth() + 1).padStart(2, '0') + '-' +
      String(targetSaturday.getDate()).padStart(2, '0');
    console.log('📅 Weekly Deal 배송 범위 (자동):', startStr, '~', endStr);
    return { start: targetMonday, end: targetSaturday, startStr: startStr, endStr: endStr };
  }
  
  // ===================================
  // 🎯 event-system 이벤트 제품 감지
  // ===================================
  
  function hasEventSystemProducts() {
    if (window._lastEventDetection && window._lastEventDetection.length > 0) {
      console.log('🎯 Event-system 제품 감지됨 → weekly deal 캘린더 필터 스킵');
      return true;
    }
    return false;
  }
  
  // ===================================
  // 📅 캘린더 날짜 숨기기만 (클릭 없음)
  // ===================================
  
  function filterCalendarDatesOnly() {
    var range = getWeeklyDealDateRange();
    var dateOptions = document.querySelectorAll('.date-option');
    if (dateOptions.length === 0) return;
    
    for (var i = 0; i < dateOptions.length; i++) {
      var option = dateOptions[i];
      var dateStr = option.dataset.date;
      if (!dateStr) continue;
      
      var parts = dateStr.split('-');
      var optionDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
      
      if (optionDate >= range.start && optionDate <= range.end) {
        option.style.display = '';
      } else {
        option.style.display = 'none';
      }
    }
    
    updateWeeklyDealSubtitle(range);
  }
  
  // ===================================
  // 📅 캘린더 필터링 + 첫 날짜 자동 선택
  // ===================================
  
  function applyWeeklyDealCalendarFilter() {
    if (hasEventSystemProducts()) {
      console.log('⏭️ Event-system 우선 → weekly deal 캘린더 필터 안 함');
      return;
    }
    
    if (!hasDealInCart) {
      restoreNormalCalendar();
      return;
    }


    
    var range = getWeeklyDealDateRange();
    var dateOptions = document.querySelectorAll('.date-option');
    if (dateOptions.length === 0) return;
    
    var visibleCount = 0;
    var hiddenCount = 0;
    
    for (var i = 0; i < dateOptions.length; i++) {
      var option = dateOptions[i];
      var dateStr = option.dataset.date;
      if (!dateStr) continue;
      
      var parts = dateStr.split('-');
      var optionDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
      
      if (optionDate >= range.start && optionDate <= range.end) {
        option.style.display = '';
        visibleCount++;
      } else {
        option.style.display = 'none';
        hiddenCount++;
      }
    }
    
    console.log('📅 Weekly Deal 캘린더 필터: ' + visibleCount + '개 표시, ' + hiddenCount + '개 숨김');
    
    if (visibleCount === 0) {
      // 선택 가능한 날짜 없음 → 무료증정 제거 + 캘린더 복원
      console.log('📅 범위 내 배송 가능 날짜 없음 → 무료증정 제거');
      restoreNormalCalendar();
      if (hasFreeGiftInCart) {
        var removeUpdate = {};
        removeUpdate[FREE_GIFT_VARIANT_ID] = 0;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: removeUpdate })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          showNotification('Free gift is not available for your delivery dates.', 'warning');
          var cartItems = document.getElementById('main-cart-items');
          if (cartItems) {
            cartItems.style.opacity = '0.4';
            cartItems.style.pointerEvents = 'none';
            cartItems.style.transition = 'opacity 0.15s ease';
          }
          window.location.reload();
        });
      }
      return;
    }

    selectFirstVisibleDate();
    updateWeeklyDealSubtitle(range);
  }
  
  function restoreNormalCalendar() {
    var dateOptions = document.querySelectorAll('.date-option');
    var wasFiltered = false;
    
    for (var i = 0; i < dateOptions.length; i++) {
      if (dateOptions[i].style.display === 'none') wasFiltered = true;
      dateOptions[i].style.display = '';
    }
    
    if (wasFiltered) {
      var subtitle = document.getElementById('calendar-subtitle');
      if (subtitle) {
        var today = new Date();
        var mn = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        var dn = ['SUN','MON','TUE','WED','THU','FRI','SAT'];
        var todayText = '[Today: ' + mn[today.getMonth()] + ' ' + today.getDate() + ' ' + dn[today.getDay()] + ']';
        
        var fulfillment = document.getElementById('selectedFulfillmentMethod');
        var isPickup = fulfillment && fulfillment.value === 'pickup';
        var msg = isPickup ? 'Please select your pickup date.' : 'Please select your delivery date.';
        subtitle.innerHTML = todayText + ' - ' + msg;
        subtitle.style.color = '#808080';
      }
      console.log('🔄 캘린더 정상 복원');
    }
  }
  
  function selectFirstVisibleDate() {
    var dateOptions = document.querySelectorAll('.date-option');
    
    for (var i = 0; i < dateOptions.length; i++) {
      var option = dateOptions[i];
      if (option.style.display !== 'none') {
        var allOptions = document.querySelectorAll('.date-option');
        for (var j = 0; j < allOptions.length; j++) {
          allOptions[j].classList.remove('selected');
          allOptions[j].style.background = '';
          allOptions[j].style.borderColor = '';
          allOptions[j].style.color = '';
        }
        
        option.click();
        console.log('📅 첫 번째 날짜 자동 선택:', option.dataset.date);
        break;
      }
    }
  }
  
  function updateWeeklyDealSubtitle(range) {
    var subtitle = document.getElementById('calendar-subtitle');
    if (!subtitle) return;
    
    var today = new Date();
    var mn = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var dn = ['SUN','MON','TUE','WED','THU','FRI','SAT'];
    var todayText = '[Today: ' + mn[today.getMonth()] + ' ' + today.getDate() + ' ' + dn[today.getDay()] + ']';
    
    var startMonth = range.start.getMonth() + 1;
    var startDay = range.start.getDate();
    var endMonth = range.end.getMonth() + 1;
    var endDay = range.end.getDate();
    
    var rangeMsg = 'Weekly Special delivery: ' + startMonth + '/' + startDay + ' - ' + endMonth + '/' + endDay;
    
    subtitle.innerHTML = todayText + ' ' + rangeMsg;
    subtitle.style.color = '#FF4713';
  }
  
  // ===================================
  // 💰 장바구니 분석 (DOM 기반)
  // ===================================
  
  function analyzeCartFromDOM() {
    var rows = document.querySelectorAll('tr.cart-item[data-tags]');
    var dealItems = [];
    var cartTotal = 0;
    var freeGiftDetected = false;
    var freeGiftVariantId = null;
    var freeGiftQuantity = 0;
    
    rows.forEach(function(row) {
      var tags = (row.getAttribute('data-tags') || '').split(',');
      var hasDealTag = tags.some(function(tag) {
        return tag.trim() === DEAL_TAG;
      });
      
      var qtyInput = row.querySelector('.quantity__input');
      if (!qtyInput) return;
      
      var variantId = qtyInput.getAttribute('data-quantity-variant-id');
      var quantity = parseInt(qtyInput.value, 10) || 1;

      // SKU 감지: data-sku 속성 또는 row의 다른 속성에서 읽기
      var sku = row.getAttribute('data-sku') || row.getAttribute('data-variant-sku') || '';

      // 무료증정 감지: Variant ID 우선, SKU fallback
      if (variantId === FREE_GIFT_VARIANT_ID || sku === FREE_GIFT_SKU) {
        freeGiftDetected = true;
        freeGiftVariantId = variantId;
        freeGiftQuantity = quantity;
        console.log('🎁 무료증정 아이템 감지 (DOM):', variantId, 'Qty:', quantity);
      }
      
      var priceEl = null;
      var allPrices = row.querySelectorAll('.cart-item__totals price-money bdi');
      if (allPrices.length > 0) {
        priceEl = allPrices[allPrices.length - 1];
      }
      
      var linePrice = 0;
      if (priceEl) {
        var priceText = priceEl.textContent.replace(/[^0-9.]/g, '');
        linePrice = parseFloat(priceText) || 0;
      }
      
      cartTotal += linePrice;
      
      if (hasDealTag) {
        dealItems.push({
          id: variantId,
          quantity: quantity,
          sku: sku,
          row: row
        });
        console.log('  ✅ Deal item (DOM):', variantId, 'SKU:', sku, 'Qty:', quantity, '$' + linePrice.toFixed(2));
      } else {
        console.log('  📦 Regular item (DOM): $' + linePrice.toFixed(2));
      }
    });
    
    console.log('  💰 Cart total: $' + cartTotal.toFixed(2));
    console.log('  🎁 Free gift in cart:', freeGiftDetected);
    
    return {
      dealItems: dealItems,
      cartTotal: cartTotal,
      totalDealQuantity: dealItems.reduce(function(sum, item) {
        return sum + item.quantity;
      }, 0),
      freeGiftDetected: freeGiftDetected,
      freeGiftVariantId: freeGiftVariantId,
      freeGiftQuantity: freeGiftQuantity
    };
  }
  
  // ===================================
  // 💰 장바구니 분석 (API fallback)
  // ===================================
  
  function analyzeCartFromAPI() {
    return fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var dealItems = [];
        var cartTotal = cart.total_price / 100;
        var freeGiftDetected = false;
        var freeGiftVariantId = null;
        var freeGiftQuantity = 0;

        // 무료증정 SKU 먼저 체크
        cart.items.forEach(function(item) {
          if (item.sku === FREE_GIFT_SKU || String(item.id) === FREE_GIFT_VARIANT_ID) {
            freeGiftDetected = true;
            freeGiftVariantId = item.id;
            freeGiftQuantity = item.quantity;
            console.log('🎁 무료증정 아이템 감지 (API):', item.id, 'Qty:', item.quantity);
          }
        });
        
        var tagPromises = cart.items.map(function(item) {
          return fetch('/products/' + item.handle + '.js')
            .then(function(r) { return r.json(); })
            .then(function(product) {
              var tags = (product.tags || []).map(function(t) { return t.toLowerCase(); });
              return { item: item, hasDealTag: tags.indexOf(DEAL_TAG) !== -1 };
            })
            .catch(function() {
              return { item: item, hasDealTag: false };
            });
        });
        
        return Promise.all(tagPromises).then(function(results) {
          results.forEach(function(result) {
            if (result.hasDealTag) {
              dealItems.push({
                id: result.item.id,
                quantity: result.item.quantity,
                sku: result.item.sku
              });
            }
          });
          
          return {
            dealItems: dealItems,
            cartTotal: cartTotal,
            totalDealQuantity: dealItems.reduce(function(sum, item) {
              return sum + item.quantity;
            }, 0),
            freeGiftDetected: freeGiftDetected,
            freeGiftVariantId: freeGiftVariantId,
            freeGiftQuantity: freeGiftQuantity
          };
        });
      });
  }
  
  // ===================================
  // 🎁 최소주문금액 동적 업데이트
  // ===================================

  function updateMinCartTotal(freeGiftDetected) {
    var previous = MIN_CART_TOTAL;

    if (freeGiftDetected) {
      MIN_CART_TOTAL = FREE_GIFT_MIN_CART_TOTAL; // $100
    } else {
      MIN_CART_TOTAL = DEFAULT_MIN_CART_TOTAL;   // $120
    }

    if (previous !== MIN_CART_TOTAL) {
      console.log('🎁 최소주문금액 변경: $' + previous + ' → $' + MIN_CART_TOTAL);
    }
  }
  
  // ===================================
  // 🔧 규칙 적용
  // ===================================
  
  function enforceRules(analysis) {
    var previousHasDeal = hasDealInCart;
    hasDealInCart = analysis.dealItems.length > 0;
    hasFreeGiftInCart = analysis.freeGiftDetected;

    // 🎁 1단계: 무료증정 자동 add/remove 먼저 실행
    // reloading=true 이면 페이지 리로드 중 → 나머지 로직 스킵
    return manageFreeGift(analysis).then(function(reloading) {
      if (reloading) return;

      // 무료증정 상태 반영 후 최소주문금액 업데이트
      updateMinCartTotal(hasFreeGiftInCart);

      // ✅ 김치 사전예약 + 1+1 동시 담기 방지
      if (hasDealInCart) {
        return fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var hasKimchi = cart.items.some(function(item) {
              return KIMCHI_SKUS.indexOf(item.sku) !== -1;
            });

            if (hasKimchi) {
              console.log('🚨 김치 + 1+1 동시 감지 → 1+1 제거');
              var removeUpdates = {};
              analysis.dealItems.forEach(function(item) {
                removeUpdates[item.id] = 0;
              });
              showNotification('Pre-order kimchi and 1+1 items cannot be ordered together. The 1+1 item has been removed.', 'warning');
              return updateCart(removeUpdates);
            }

            return applyNormalRules(analysis, previousHasDeal);
          });
      }

      return applyNormalRules(analysis, previousHasDeal);
    });
  }

  // ===================================
  // 🎁 Shop 메타필드에서 무료증정 날짜 읽기
  // ===================================

  function getFreeGiftDateRange() {
    return fetch('/api/2023-10/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        query: '{ shop { metafield(namespace: "freegift", key: "start_date") { value } } }'
      })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      // Storefront API 없이 쓸 수 없으므로 window 변수 fallback 사용
      return null;
    })
    .catch(function() { return null; });
  }

  // Liquid에서 주입된 메타필드 값 읽기
  // theme.liquid에 아래 스크립트 추가 필요:
  // <script>
  //   window.freeGiftConfig = {
  //     startDate: "{{ shop.metafields.freegift.start_date.value }}",
  //     endDate: "{{ shop.metafields.freegift.end_date.value }}"
  //   };
  // </script>
  function getFreeGiftConfig() {
    if (window.freeGiftConfig && window.freeGiftConfig.startDate) {
      return window.freeGiftConfig;
    }
    return null;
  }

  // ===================================
  // 🎁 무료증정 자동 add/remove
  // ===================================

  function manageFreeGift(analysis) {
    var config = getFreeGiftConfig();

    // 메타필드 미설정 시 무료증정 비활성 (이벤트 없는 주)
    if (!config || !config.startDate || !config.endDate) {
      console.log('🎁 무료증정 메타필드 미설정 → 이벤트 없는 주');
      if (analysis.freeGiftDetected) {
        console.log('🎁 메타필드 없음 → 무료증정 제거');
        showNotification('Free gift event has ended.', 'warning');
        return addOrRemoveFreeGift(false, analysis.freeGiftDetected);
      }
      return Promise.resolve(false);
    }

    var startDate = new Date(config.startDate + 'T00:00:00');
    var endDate = new Date(config.endDate + 'T23:59:59');

    console.log('🎁 무료증정 날짜 범위:', config.startDate, '~', config.endDate);

    // 카트 attributes에서 배송일 읽기
    return fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var deliveryDateStr = cart.attributes && cart.attributes['Delivery Date'];
        // 무료증정($0) 제외한 실제 카트 합계 계산
        var cartTotal = 0;
        cart.items.forEach(function(item) {
          if (String(item.variant_id) !== FREE_GIFT_VARIANT_ID) {
            cartTotal += item.final_line_price / 100;
          }
        });

        console.log('🎁 배송일:', deliveryDateStr, '| 실제 카트 합계: $' + cartTotal.toFixed(2));

        var meetsMinimum = cartTotal >= FREE_GIFT_MIN_CART_TOTAL;

        // 캘린더에 실제로 선택 가능한 날짜가 있는지 확인
        var dateOptions = document.querySelectorAll('.date-option');
        var availableDatesInRange = 0;
        dateOptions.forEach(function(opt) {
          var dateStr = opt.dataset.date;
          if (!dateStr) return;
          var parts = dateStr.split('-');
          var optDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
          if (optDate >= startDate && optDate <= endDate) availableDatesInRange++;
        });

        var hasValidDates = availableDatesInRange > 0;
        console.log('🎁 $100 이상:', meetsMinimum, '| 범위 내 배송 가능 날짜:', availableDatesInRange);

        // 유효한 날짜 없으면 추가하지 않음 (무한루프 방지)
        var isEligible = meetsMinimum && hasValidDates;
        return addOrRemoveFreeGift(isEligible, analysis.freeGiftDetected);
      });
  }

  // ===================================
  // 🔄 카트 섹션 AJAX 업데이트 (reload 대신)
  // ===================================

  var CART_SECTION_IDS = [
    'template--22152486060257__cart-items',
    'template--22152486060257__cart-footer'
  ];

  function refreshCartSections() {
    // 처리 플래그 유지 (reload 전까지 추가 트리거 완전 차단)
    isProcessing = true;
    isFreeGiftProcessing = true;
    var cartItems = document.getElementById('main-cart-items');
    if (cartItems) {
      cartItems.style.opacity = '0.4';
      cartItems.style.pointerEvents = 'none';
      cartItems.style.transition = 'opacity 0.15s ease';
    }
    window.location.reload();
    return Promise.resolve();
  }

  function addOrRemoveFreeGift(shouldHave, hasGift) {
    // 중복 실행 방지
    if (isFreeGiftProcessing) {
      console.log('🎁 무료증정 처리 중 → 스킵');
      return Promise.resolve(false);
    }

    // 상태가 동일하면 실행 안 함
    var stateKey = (shouldHave ? '1' : '0') + '-' + (hasGift ? '1' : '0');
    if (lastFreeGiftState === stateKey && !(shouldHave && !hasGift) && !(!shouldHave && hasGift)) {
      console.log('🎁 무료증정 상태 동일 → 스킵');
      return Promise.resolve(false);
    }
    lastFreeGiftState = stateKey;

    if (shouldHave && !hasGift) {
      console.log('🎁 무료증정 자동 추가!');
      isFreeGiftProcessing = true;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(FREE_GIFT_VARIANT_ID),
            quantity: 1,
            properties: { _free_gift: 'true' }
          }]
        })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        showNotification('Free gift added to your cart!', 'info');
        return refreshCartSections().then(function() { return true; });
      })
      .catch(function(err) {
        console.error('🎁 무료증정 추가 실패:', err);
        return false;
      });

    } else if (!shouldHave && hasGift) {
      console.log('🎁 조건 미충족 → 무료증정 제거');
      isFreeGiftProcessing = true;
      var removeUpdate = {};
      removeUpdate[FREE_GIFT_VARIANT_ID] = 0;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: removeUpdate })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        showNotification('Free gift removed. Add $100+ with a 4/13-4/18 delivery date to qualify.', 'warning');
        return refreshCartSections().then(function() { return true; });
      });

    } else {
      console.log('🎁 무료증정 상태 유지 (shouldHave:' + shouldHave + ' hasGift:' + hasGift + ')');
      return Promise.resolve(false);
    }
  }

  // ===================================
  // 🔧 일반 규칙 적용
  // ===================================

  function applyNormalRules(analysis, previousHasDeal) {
    var updates = {};
    var needsUpdate = false;
    var quantityAdjusted = false;

    // 규칙 1: weekly-deal 수량 1개 초과 → 1개로 강제 (무료증정 제외한 deal 아이템만)
    var nonGiftDealItems = analysis.dealItems.filter(function(item) {
      return item.sku !== FREE_GIFT_SKU;
    });

    var nonGiftTotalQty = nonGiftDealItems.reduce(function(sum, item) {
      return sum + item.quantity;
    }, 0);

    if (nonGiftTotalQty > MAX_DEAL_QUANTITY) {
      nonGiftDealItems.forEach(function(item, index) {
        if (index === 0) {
          updates[item.id] = MAX_DEAL_QUANTITY;
        } else {
          updates[item.id] = 0;
        }
        needsUpdate = true;
        quantityAdjusted = true;
      });
      console.log('🚨 weekly-deal 수량 ' + nonGiftTotalQty + ' → 1개로 강제');
    }

    // 규칙 2: 무료증정 아이템 수량 1개 초과 → 1개로 강제
    if (analysis.freeGiftDetected && analysis.freeGiftQuantity > MAX_DEAL_QUANTITY) {
      updates[analysis.freeGiftVariantId] = MAX_DEAL_QUANTITY;
      needsUpdate = true;
      quantityAdjusted = true;
      console.log('🚨 무료증정 수량 ' + analysis.freeGiftQuantity + ' → 1개로 강제');
    }
    
    if (needsUpdate) {
      return updateCart(updates).then(function() {
        var translations = window.weeklyDealTranslations || {};
        if (quantityAdjusted) {
          var message = translations.quantity_limit || 'Limited to 1 per order';
          showNotification(message, 'info');
        }
      });
    }
    
    // 캘린더 필터: deal 상태가 변경될 때만
    if (hasDealInCart && !previousHasDeal) {
      console.log('📅 특가 추가됨 → 캘린더 필터 적용');
      setTimeout(applyWeeklyDealCalendarFilter, 200);
    } else if (!hasDealInCart && previousHasDeal) {
      console.log('📅 특가 제거됨 → 캘린더 복원');
      restoreNormalCalendar();
    }
    
    // $120 or $100 미만 체크아웃 차단
    if (hasDealInCart && analysis.cartTotal < MIN_CART_TOTAL) {
      blockCheckout(analysis.cartTotal);
    } else {
      unblockCheckout();
    }
    
    // CSS 클래스 수량 잠금 재적용 (weekly-deal + 무료증정 모두)
    if (hasDealInCart || hasFreeGiftInCart) {
      disableQuantityButtons(analysis.freeGiftVariantId);
    }

    console.log('✅ 규칙 통과 (최소주문금액: $' + MIN_CART_TOTAL + ')');
    return Promise.resolve();
  }
  
  // ===================================
  // 🚫 체크아웃 차단/해제
  // ===================================
  
  function blockCheckout(cartTotal) {
    var checkoutBtn = document.querySelector('button[name="checkout"]') || 
                      document.getElementById('checkout') ||
                      document.querySelector('[name="checkout"]') ||
                      document.querySelector('.cart__checkout-button');
    
    if (!checkoutBtn) return;
    
    checkoutBtn.disabled = true;
    checkoutBtn.style.opacity = '0.5';
    checkoutBtn.style.cursor = 'not-allowed';
    checkoutBtn.style.pointerEvents = 'none';
    
    var existingMsg = document.getElementById('weekly-deal-checkout-msg');
    var remaining = (MIN_CART_TOTAL - cartTotal).toFixed(2);
    var translations = window.weeklyDealTranslations || {};
    var message = translations.checkout_blocked || 
      'Add $' + remaining + ' more to use the weekly special (min. $' + MIN_CART_TOTAL + ')';
    
    if (!existingMsg) {
      var msg = document.createElement('div');
      msg.id = 'weekly-deal-checkout-msg';
      msg.style.cssText = 
        'color:#FF4713;font-size:13px;font-weight:500;' +
        'text-align:center;padding:8px 12px;margin-top:8px;' +
        'background:#FFF5F2;border-radius:6px;';
      msg.innerHTML = message;
      checkoutBtn.parentNode.insertBefore(msg, checkoutBtn.nextSibling);
    } else {
      existingMsg.innerHTML = message;
    }
    
    console.log('🚫 체크아웃 차단 - Cart: $' + cartTotal.toFixed(2) + ' < $' + MIN_CART_TOTAL);
  }
  
  function unblockCheckout() {
    var checkoutBtn = document.querySelector('button[name="checkout"]') || 
                      document.getElementById('checkout') ||
                      document.querySelector('[name="checkout"]') ||
                      document.querySelector('.cart__checkout-button');
    
    if (checkoutBtn) {
      checkoutBtn.disabled = false;
      checkoutBtn.style.opacity = '';
      checkoutBtn.style.cursor = '';
      checkoutBtn.style.pointerEvents = '';
    }
    
    var existingMsg = document.getElementById('weekly-deal-checkout-msg');
    if (existingMsg) existingMsg.remove();
  }
  
  // ===================================
  // 🔄 메인 체크 함수
  // ===================================
  
  function enforceWeeklyDealRules() {
    if (isProcessing) return Promise.resolve();
    isProcessing = true;
    
    var hasDataTags = document.querySelector('tr.cart-item[data-tags]');
    var analyzePromise;
    
    if (hasDataTags) {
      console.log('⚡ DOM 기반 즉시 분석');
      analyzePromise = Promise.resolve(analyzeCartFromDOM());
    } else {
      console.log('🌐 API fallback 분석');
      analyzePromise = analyzeCartFromAPI();
    }
    
    return analyzePromise
      .then(function(analysis) {
        return enforceRules(analysis);
      })
      .then(function() {
        isProcessing = false;
      })
      .catch(function(error) {
        console.error('❌ Error:', error);
        isProcessing = false;
      });
  }
  
  // ===================================
  // 🔒 수량 버튼 비활성화 (CSS 클래스만)
  // weekly-deal 태그 아이템 + 무료증정 아이템 모두 잠금
  // ===================================
  
  function disableQuantityButtons(freeGiftVariantId) {
    var rows = document.querySelectorAll('tr.cart-item[data-tags]');
    
    rows.forEach(function(row) {
      var tags = (row.getAttribute('data-tags') || '').split(',');
      var hasDealTag = tags.some(function(tag) {
        return tag.trim() === DEAL_TAG;
      });

      // 무료증정 아이템도 잠금: Variant ID 우선, SKU fallback
      var sku = row.getAttribute('data-sku') || row.getAttribute('data-variant-sku') || '';
      var qtyInput = row.querySelector('.quantity__input');
      var rowVariantId = qtyInput ? qtyInput.getAttribute('data-quantity-variant-id') : '';
      var isFreeGift = rowVariantId === FREE_GIFT_VARIANT_ID || sku === FREE_GIFT_SKU;
      
      if (hasDealTag || isFreeGift) {
        row.classList.add('weekly-deal-locked');
      } else {
        row.classList.remove('weekly-deal-locked');
      }
    });
  }
  
  // ===================================
  // 🛒 Cart Drawer 안내 메시지
  // ===================================
  
  function addDrawerNotices() {
    var drawerItems = document.querySelectorAll('.mini-cart__navigation li[data-tags]');
    if (!drawerItems.length) return;
    
    drawerItems.forEach(function(li) {
      var tags = (li.getAttribute('data-tags') || '').split(',');
      var hasDeal = tags.some(function(tag) {
        return tag.trim() === DEAL_TAG;
      });
      
      if (!hasDeal) return;
      if (li.querySelector('.weekly-deal-drawer-notice')) return;
      
      var notice = document.createElement('div');
      notice.className = 'weekly-deal-drawer-notice';
      notice.style.cssText = 
        'font-size:11px;color:#FF4713;padding:6px 8px;margin-top:4px;' +
        'font-weight:500;background:#FFF5F2;border-radius:4px;line-height:1.6;';
      
      var translations = window.weeklyDealTranslations || {};

      // 무료증정 아이템일 때와 일반 weekly-deal일 때 메시지 분기
      var sku = li.getAttribute('data-sku') || li.getAttribute('data-variant-sku') || '';
      var liVariantId = li.getAttribute('data-variant-id') || '';
      var isFreeGift = sku === FREE_GIFT_SKU || liVariantId === FREE_GIFT_VARIANT_ID;

      var line1, line2;
      if (isFreeGift) {
        line1 = translations.free_gift_limit || 'Free gift: Limited to 1 per order';
        line2 = translations.free_gift_minimum || 'Requires $' + FREE_GIFT_MIN_CART_TOTAL + '+ purchase';
      } else {
        line1 = translations.quantity_limit || 'Limited to 1 per order';
        line2 = translations.under_minimum || 'Requires $' + DEFAULT_MIN_CART_TOTAL + '+ in regular items';
      }

      notice.innerHTML = line1 + ' &middot; ' + line2;
      
      var container = li.querySelector('.product-container');
      if (container) {
        container.after(notice);
        console.log('📌 Drawer 안내 추가');
      }
    });
  }
  
  // ===================================
  // 🛒 카트 업데이트
  // ===================================
  
  function updateCart(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
    .then(function(response) { return response.json(); })
    .then(function() {
      var cartItems = document.getElementById('main-cart-items');
      if (cartItems) {
        cartItems.style.opacity = '0.4';
        cartItems.style.pointerEvents = 'none';
        cartItems.style.transition = 'opacity 0.15s ease';
      }
      window.location.reload();
    });
  }
  
  // ===================================
  // 💬 알림 메시지
  // ===================================
  
  function showNotification(message, type) {
    type = type || 'info';

    // 기존 알림 제거
    var existing = document.querySelector('.weekly-deal-notification');
    if (existing) existing.remove();
    
    var notification = document.createElement('div');
    notification.className = 'weekly-deal-notification weekly-deal-notification--' + type;

    var icon = document.createElement('div');
    icon.className = 'weekly-deal-notification__icon';
    icon.textContent = type === 'info' ? '🎁' : '🛒';
    
    var messageEl = document.createElement('div');
    messageEl.className = 'weekly-deal-notification__message';
    messageEl.textContent = message;
    
    var closeBtn = document.createElement('button');
    closeBtn.className = 'weekly-deal-notification__close';
    closeBtn.innerHTML = '&times;';
    closeBtn.onclick = function() {
      notification.classList.remove('show');
      setTimeout(function() { notification.remove(); }, 400);
    };
    
    notification.appendChild(icon);
    notification.appendChild(messageEl);
    notification.appendChild(closeBtn);
    document.body.appendChild(notification);
    
    setTimeout(function() { notification.classList.add('show'); }, 50);
    
    setTimeout(function() {
      notification.classList.remove('show');
      setTimeout(function() { notification.remove(); }, 400);
    }, 4000);
  }
  
  // ===================================
  // 👂 이벤트 리스너
  // ===================================
  
  function setupListeners() {
    ['click', 'touchend'].forEach(function(eventType) {
      document.addEventListener(eventType, function(e) {
        var target = e.target;
        
        var lockedRow = target.closest('.weekly-deal-locked');
        if (lockedRow) {
          var isQtyBtn = target.closest('.quantity__button') || 
                        target.closest('button[name="plus"]') || 
                        target.closest('button[name="minus"]');
          if (isQtyBtn) return;
        }
        
        var isQuantityButton = target.closest('.quantity__button') || 
                              target.closest('button[name="plus"]') || 
                              target.closest('button[name="minus"]');
        
        var isRemoveButton = target.closest('cart-remove-button') || 
                            target.closest('.cart-item__remove');
        
        if (isQuantityButton || isRemoveButton) {
          setTimeout(enforceWeeklyDealRules, 500);
        }
      }, { passive: true });
    });
    
    document.addEventListener('change', function(e) {
      if (e.target.classList.contains('quantity__input')) {
        setTimeout(enforceWeeklyDealRules, 500);
      }
    });
    
    // 카트 이벤트 감지 (수량 변경, 삭제 등)
    ['cart:updated', 'cart:change', 'cart:refresh'].forEach(function(eventName) {
      document.addEventListener(eventName, function() {
        setTimeout(enforceWeeklyDealRules, 300);
      });
    });

    // Shopify 공식 카트 구독 (상품 추가 감지)
    if (window.Shopify && window.Shopify.on) {
      window.Shopify.on('cart:item-added', function() {
        setTimeout(enforceWeeklyDealRules, 400);
      });
    }

    // MutationObserver로 카트 아이템 DOM 변화 감지 (상품 추가 시)
    var cartItemsEl = document.getElementById('main-cart-items');
    if (cartItemsEl) {
      var cartItemObserver = new MutationObserver(function(mutations) {
        var hasSignificantChange = mutations.some(function(m) {
          return m.type === 'childList' && (m.addedNodes.length > 0 || m.removedNodes.length > 0);
        });
        if (hasSignificantChange) {
          setTimeout(enforceWeeklyDealRules, 400);
        }
      });
      cartItemObserver.observe(cartItemsEl, { childList: true, subtree: true });
    }
    
    document.addEventListener('cartdrawer:opened', function() {
      setTimeout(addDrawerNotices, 300);
    });
    
    var miniCartEl = document.getElementById('mini-cart');
    if (miniCartEl) {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            setTimeout(addDrawerNotices, 200);
          }
        });
      });
      observer.observe(miniCartEl, { childList: true, subtree: true });
    }
    
    window.addEventListener('calendarRendered', function() {
      if (hasDealInCart) {
        if (!calendarInitialized) {
          calendarInitialized = true;
          setTimeout(applyWeeklyDealCalendarFilter, 150);
        } else {
          setTimeout(filterCalendarDatesOnly, 150);
        }
      }
    });
    
    window.addEventListener('chefBanchanFulfillmentChanged', function() {
      if (hasDealInCart) {
        calendarInitialized = false;
        setTimeout(applyWeeklyDealCalendarFilter, 300);
      }
    });

  }
  
  // ===================================
  // 🎨 스타일
  // ===================================
  
  function injectStyles() {
    var style = document.createElement('style');
    style.textContent = 
      '.weekly-deal-locked .quantity__button[name="plus"],' +
      '.weekly-deal-locked .quantity__button[name="minus"],' +
      '.weekly-deal-locked button[name="plus"],' +
      '.weekly-deal-locked button[name="minus"] {' +
        'opacity: 0.3 !important;' +
        'cursor: not-allowed !important;' +
        'pointer-events: none !important;' +
      '}' +
      '.weekly-deal-locked .quantity__input {' +
        'opacity: 0.6 !important;' +
        'cursor: not-allowed !important;' +
        'pointer-events: none !important;' +
      '}' +
      '.weekly-deal-notification {' +
        'position: fixed; bottom: 24px; left: 50%;' +
        'transform: translateX(-50%) translateY(80px);' +
        'padding: 14px 16px;' +
        'border-radius: 14px;' +
        'z-index: 10000; opacity: 0;' +
        'transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);' +
        'font-size: 13px; font-weight: 500;' +
        'width: calc(100% - 32px); max-width: 360px;' +
        'display: flex; align-items: center; gap: 12px;' +
      '}' +
      '.weekly-deal-notification.show {' +
        'opacity: 1; transform: translateX(-50%) translateY(0);' +
      '}' +
      '.weekly-deal-notification--info {' +
        'background: #FF4713;' +
      '}' +
      '.weekly-deal-notification--info .weekly-deal-notification__message { color: #fff; }' +
      '.weekly-deal-notification--info .weekly-deal-notification__close { color: rgba(255,255,255,0.8); }' +
      '.weekly-deal-notification--warning {' +
        'background: white; border: 0.5px solid rgba(0,0,0,0.12);' +
        'box-shadow: 0 4px 20px rgba(0,0,0,0.12);' +
      '}' +
      '.weekly-deal-notification--warning .weekly-deal-notification__message { color: #222; }' +
      '.weekly-deal-notification--warning .weekly-deal-notification__close { color: #999; }' +
      '.weekly-deal-notification__icon {' +
        'width: 32px; height: 32px; border-radius: 50%;' +
        'display: flex; align-items: center; justify-content: center;' +
        'flex-shrink: 0; font-size: 16px;' +
      '}' +
      '.weekly-deal-notification--info .weekly-deal-notification__icon { background: rgba(255,255,255,0.2); }' +
      '.weekly-deal-notification--warning .weekly-deal-notification__icon { background: #f5f5f5; }' +
      '.weekly-deal-notification__message { flex: 1; line-height: 1.4; }' +
      '.weekly-deal-notification__close {' +
        'width: 24px; height: 24px; border: none;' +
        'background: transparent;' +
        'font-size: 18px; line-height: 1; cursor: pointer;' +
        'display: flex; align-items: center; justify-content: center;' +
        'border-radius: 4px; padding: 0; flex-shrink: 0;' +
      '}';
    
    document.head.appendChild(style);
  }
  
  // ===================================
  // ⚡ 초기화
  // ===================================
  
  function initialize() {
    console.log('🚀 Weekly Deal V3.14 Init');
    
    injectStyles();
    setupListeners();
    
    if (document.querySelector('tr.cart-item')) {
      setTimeout(function() {
        enforceWeeklyDealRules().then(function() {
          disableQuantityButtons(null);
          if (hasDealInCart) {
            setTimeout(applyWeeklyDealCalendarFilter, 300);
          }
        });
      }, 100);
    }
    
    setTimeout(addDrawerNotices, 300);
    
    console.log('✅ V3.14 Ready');
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    setTimeout(initialize, 100);
  }
  
  window.weeklyDealManager = {
    check: enforceWeeklyDealRules,
    analyze: function() { return Promise.resolve(analyzeCartFromDOM()); },
    disableButtons: disableQuantityButtons,
    checkDrawer: addDrawerNotices,
    applyCalendarFilter: applyWeeklyDealCalendarFilter,
    getDateRange: getWeeklyDealDateRange,
    hasDeal: function() { return hasDealInCart; },
    hasFreeGift: function() { return hasFreeGiftInCart; },         // 🎁 신규
    getMinTotal: function() { return MIN_CART_TOTAL; }             // 🎁 신규
  };
  
})();